module.exports = __webpack_public_path__ + "img/cspacemagenta.1a7c8783.svg";